import resources from '../../assets/locales/resources';
import './utils/setRtlByLang';
import { i18nClient } from '@sailor/i18n-web';
import { transLang } from '@/utils/i18n';
import { SSOGuard } from '@mtfe/sso-web';
import { collectUUIdPromise } from '@/utils/device';

// 只有需要登录的页面才初始化cookie防盗
if (/^\/certification\//.test(window.location.pathname)) {
  const isProdOrSt = window.location.host === 'ssosv.sankuai.com' || window.location.host === 'ssosv.it.st.sankuai.com' || window.location.host === 'iamsrv.sankuai.com' || window.location.host === 'iamsrv.it.st.sankuai.com';
  const ssoGuard = new SSOGuard({
    clientId: '60b0d8def9',
    appkey: 'com.sankuai.oa.it.ssoweb',
    isDebug: true,
    accessEnv: isProdOrSt ? 'product' : 'test',
  });
  ssoGuard.init();
}

// 判断是否为大象环境,是大象则读取大象设置的语言来设置默认语言
function getDaXiangLang() {
  const { userAgent } = navigator;
  const daXiangUaReg = new RegExp('dx_la\\/(zh|zh-HK|en)$', 'i');
  const daxiangUAMatch = userAgent.match(daXiangUaReg);
  if (daxiangUAMatch && daxiangUAMatch.length > 0) {
    const daxiangLang = daxiangUAMatch[1] as string;
    return daxiangLang;
  }
  return null;
}
function initI18nLocal() {
  i18nClient.init({
    ns: 'SSO_Web',
    fallbackLng: transLang(getDaXiangLang() || navigator.language),
    resources,
    detection: { // 语言自动识别配置
      order: ['querystring', 'sessionStorage'], // 自动识别locale顺序
      lookupQuerystring: 'locale', // query 参数
      lookupSessionStorage: '__com_sankuai_oa_it_ssoweb__.i18nLocale', // sessionStorage key
      caches: ['sessionStorage'], // 配置缓存，如果不需要换成，可配置为空数组
    },
    react: {
      useSuspense: false
    }
  });
  document.title = i18nClient.t('sso_web_sso_info', '统一登录中心');
}

collectUUIdPromise();

// 页面初次渲染
export async function render(oldRender) {
  window.Owl
    && window.Owl.addPoint({
      position: 1,
      timeStamp: Date.now()
    });
  initI18nLocal();
  oldRender();
}
